import { render } from "./Container.vue?vue&type=template&id=665e0e52&scoped=true&ts=true"
import script from "./Container.vue?vue&type=script&lang=ts"
export * from "./Container.vue?vue&type=script&lang=ts"

import "./Container.vue?vue&type=style&index=0&id=665e0e52&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665e0e52"]])

export default __exports__